export function registerServiceWorker() {
    if (!('serviceWorker' in navigator)) {
        if (import.meta.env.DEV) {
            console.log('[PWA] Service workers not supported in this browser')
        }
        return
    }

    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/build/sw.js', { scope: '/' })
            .then((registration) => {
                if (import.meta.env.DEV) {
                    console.log('[PWA] ServiceWorker registered:', registration.scope)
                }

                registration.addEventListener('updatefound', () => {
                    const newWorker = registration.installing
                    newWorker.addEventListener('statechange', () => {
                        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                            const event = new CustomEvent('pwa-new-version', {
                                detail: { registration }
                            })
                            window.dispatchEvent(event)
                        }
                    })
                })
            })
            .catch((error) => {
                if (import.meta.env.DEV) {
                    console.warn('[PWA] ServiceWorker registration failed:', error.message)
                }
            })
    })
}

export async function subscribeToPushNotifications(publicKey) {
    if (!('serviceWorker' in navigator)) return null

    try {
        const registration = await navigator.serviceWorker.ready
        const subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(publicKey)
        })
        return subscription
    } catch (error) {
        if (import.meta.env.DEV) {
            console.warn('[PWA] Push subscription failed:', error.message)
        }
        return null
    }
}

export async function unsubscribeFromPushNotifications() {
    if (!('serviceWorker' in navigator)) return

    try {
        const registration = await navigator.serviceWorker.ready
        const subscription = await registration.pushManager.getSubscription()
        if (subscription) {
            await subscription.unsubscribe()
        }
    } catch (error) {
        if (import.meta.env.DEV) {
            console.warn('[PWA] Push unsubscription failed:', error.message)
        }
    }
}

function urlBase64ToUint8Array(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4)
    const base64 = (base64String + padding)
        .replace(/-/g, '+')
        .replace(/_/g, '/')
    const rawData = window.atob(base64)
    const outputArray = new Uint8Array(rawData.length)
    for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i)
    }
    return outputArray
}
